// GENERATED FILE, PLEASE DO NOT EDIT
export var ButtonPrimaryToggleOff = 1;
export var ButtonSecondaryToggleOff = 1;
export var ButtonPrimaryToggleGroupOn = 2;
export var ButtonSecondaryToggleGroupOn = 2;
export var ButtonTertiaryToggleGroupOn = 2;
export var PaginationNumbered = 2;